export enum ProfileAvatarSizeEnum {
  Small = "small",
  Medium = "medium",
  Large = "large",
  Big = "big",
  ExtraBig = "extraBig",
}
